import { render } from "./PixelMoon.vue?vue&type=template&id=3ce2a62e"
import script from "./PixelMoon.vue?vue&type=script&lang=js"
export * from "./PixelMoon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__